/**
 * Ephemeral session identifier service.
 *
 * Generates a session ID held **only in JavaScript memory**:
 *   - No cookies
 *   - No localStorage / sessionStorage
 *   - No fingerprinting
 *   - No visitor recognition across page loads
 *
 * The ID lives as long as the module scope (i.e. until the page/tab is closed).
 * Use this when analytics consent has not been granted, to correlate events
 * within a single page view without any persistent storage.
 */

const generateId = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return `eph_${crypto.randomUUID().replace(/-/g, '')}`;
  }
  // Fallback for older environments
  const random = Math.random().toString(36).slice(2, 12);
  const timestamp = Date.now().toString(36);
  return `eph_${timestamp}${random}`;
};

/** Session ID generated once at module load time. */
const sessionId: string = generateId();

const EphemeralSession = {
  /** Returns the single ephemeral session ID for this page view. */
  getSessionId: (): string => sessionId,
};

export default EphemeralSession;
